import { RouteName } from '@shared/constants/routes'

export const orderCancelIgnoredMessages = [
  'An order cannot be cancelled within one hour of the delivery window',
  /Cannot cancel an order with status/,
]

export const orderAlreadyProcessedIgnoredMessages = [
  /The shopper has already checked out, no action is available/i,
]

export const postOrderEligiblePages = [
  RouteName.GLOBAL_HOMEPAGE,
  RouteName.ORDER_DETAIL,
  RouteName.RETAILER_HOMEPAGE,
  RouteName.ORDER_CONFIRMATION,
  RouteName.SEARCH,
  RouteName.CART,
  RouteName.ORDER_LIST,
  RouteName.PRODUCT,
  RouteName.BUY_AGAIN,
  RouteName.GLOBAL_SEARCH,
  RouteName.SUBSTITUTION_PREFERENCES,
  RouteName.MEMBERSHIP_DASHBOARD,
  RouteName.RETAILER_LANDING_PAGE,
  RouteName.PROFILE,
  RouteName.RETAILER_DEALS,
  RouteName.WALLET,
]
